import { useQuery } from '@tanstack/react-query';
import axios from '../../Actions/axios.config';

export const userKeys = {
    all: ['users'],
    profiles: () => [...userKeys.all, 'profile'],
    profile: (id) => [...userKeys.profiles(), id],
};

export const useUserProfile = (userId) => {
    return useQuery({
        queryKey: userKeys.profile(userId),
        queryFn: async () => {
            const { data } = await axios.get(`/user/${userId}`);
            return data.userInfo;
        },
        enabled: !!userId,
    });
};
